export const SIZES = {
    xs: 24,
    s: 28,
    m: 32,
    l: 42,
    xl: 50,
};
